import React from "react";

function DocumentIcon() {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.075 0.505L16.056 5.486M4.2095 9.714H12.3465M4.2095 15.747H12.3465M4.2095 12.7305H12.3465M1.4725 0.505C1.21235 0.511395 0.965007 0.619252 0.7833 0.805537C0.601593 0.991822 0.499921 1.24177 0.5 1.502V19.003C0.500045 19.2631 0.601689 19.5129 0.783263 19.6992C0.964837 19.8854 1.21198 19.9934 1.472 20H15.084C15.3484 20 15.602 19.895 15.789 19.708C15.976 19.521 16.081 19.2674 16.081 19.003V5.486H12.0925C11.8323 5.47948 11.585 5.37151 11.4033 5.18515C11.2216 4.99878 11.1199 4.74878 11.12 4.4885V0.5L1.4725 0.505Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DocumentIcon;
